// extracted by mini-css-extract-plugin
export default {"popup":"Modal_popup__gVj0P","popup_opened":"Modal_popup_opened__d4q+8","container":"Modal_container__Yn7oD","close-btn":"Modal_close-btn__pwp-b"};